<template>
  <el-dialog :visible.sync="open" :title="title" :before-close="sendClose" width="700px">
    <el-form @keyup.enter.native="save">
      <el-tabs v-model="tabSelected">
        <el-tab-pane :label="$t('common.about')" name="resume">
          <div class="form-group-container">
            <div class="form-group-container-media">
              <library-manager
                v-show="modal.library"
                :open="modal.library"
                @close="closeLibrary"
                @selected="imgSelected"
              ></library-manager
              ><img v-bind:src="badge.media.url" />
              <el-button class="button" @click="toggleLibraryManager" size="small" plain="plain"
                >Choose from library...</el-button
              >
            </div>
            <form-group class="form-group-container-name" :label="$t('common.name')" required="required">
              <template slot="input">
                <input name="name" v-model="badge.name[lang]" :class="{ input: true }" />
              </template>
            </form-group>

            <div class="form-group form-group-container-score">
              <label>{{ $t('common.score') }}</label>
              <el-input-number v-model="badge.score" :min="0"></el-input-number>
            </div>

            <form-group class="form-group-container-description" :label="$t('common.resume')" required="required">
              <template slot="input">
                <input name="description" v-model="badge.description[lang]" :class="{ input: true }" />
              </template>
            </form-group>

            <form-group class="form-group-container-success" :label="$t('common.success')" required="required">
              <template slot="input">
                <input name="successmessage" v-model="badge.successmessage[lang]" :class="{ input: true }" />
              </template>
            </form-group>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('common.advanced')" name="advanced">
          <div class="form-group">
            <label>{{ $t('common.link') }}</label>
            <el-input v-model="badge.link"></el-input>
          </div>
          <br />
          <div class="form-group-container-advanced">
            <div class="form-group">
              <el-checkbox v-model="limitedPeriod"
                ><label>{{ $t('badge.modal.fields.period') }}</label></el-checkbox
              >
            </div>
            <div class="form-group">
              <el-checkbox v-model="limitedBadge"
                ><label>{{ $t('badge.modal.fields.maxachieved') }}</label></el-checkbox
              >
            </div>
            <div class="form-group">
              <el-date-picker
                v-model="period"
                type="daterange"
                @change="onChangePeriod"
                :disabled="!limitedPeriod"
              ></el-date-picker>
            </div>
            <div class="form-group">
              <el-input-number v-model="badge.maxachieved" :disabled="!limitedBadge" :min="-1"></el-input-number>
            </div>
            <div class="form-group">
              <el-checkbox v-model="secretBadge"><label>Secret</label></el-checkbox>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs> </el-form
    ><span class="dialog-footer" slot="footer">
      <el-button @click="sendClose" plain="plain">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LibraryManager from '../libraries/library-manager.vue'
import formGroup from '@/components/layouts/form-group.vue'

export default {
  components: { LibraryManager, formGroup },
  props: ['id', 'idCampaign', 'idParent'],
  data() {
    return {
      badge: null,
      open: true,
      tabSelected: 'resume',

      period: null,

      modal: {
        library: false
      }
    }
  },
  computed: {
    ...mapGetters('campaigns', {
      getCampaignById: 'getCampaignById'
    }),
    ...mapGetters('badges', {
      getById: 'getById'
    }),
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    title() {
      return this.id ? this.$t('badge.modal.edit.title') : this.$t('badge.modal.create.title')
    },
    limitedBadge: {
      get: function() {
        return this.badge.maxachieved !== -1
      },
      set: function(value) {
        this.badge.maxachieved = value ? 1 : -1
      }
    },
    secretBadge: {
      get: function() {
        if (this.badge.secret === 0) {
          return false
        } else if (this.badge.secret === 1) {
          return true
        }
      },
      set: function(value) {
        this.badge.secret = value ? 1 : 0
      }
    },
    limitedPeriod: {
      get: function() {
        return this.badge.activationdate !== null && this.badge.deactivationdate !== null
      },
      set: function(value) {
        if (value) {
          this.badge.activationdate = {}
          this.badge.deactivationdate = {}
        } else {
          this.badge.activationdate = null
          this.badge.deactivationdate = null
        }
      }
    }
  },
  methods: {
    ...mapActions('badges', ['addBadge', 'updateBadge']),

    sendClose(badge) {
      this.$emit('close', badge)
    },

    closeLibrary() {
      this.modal.library = false
    },
    toggleLibraryManager() {
      this.modal.library = !this.modal.library
    },
    ...mapActions('modals', ['toggle']),

    imgSelected(media) {
      this.badge.media = media
      this.toggleLibraryManager()
    },

    onChangePeriod(period) {
      if (period && period[0] && period[1]) {
        this.badge.activationdate = this._setDate(period[0], this.site.timezone, true)
        this.badge.deactivationdate = this._setDate(period[1], this.site.timezone, false)
      } else {
        this.badge.activationdate = null
        this.badge.deactivationdate = null
      }
    },

    save() {
      if (this.badge.id) {
        this.updateBadge({ badge: this.badge })
          .then(badge => {
            this.$notify({ title: 'Success', message: this.$root.$t('notifications.campaign.edited'), type: 'success' })
            this.sendClose(badge)
          })
          .catch(e => {
            this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
            this.sendClose()
          })
      } else {
        this.addBadge({ badge: this.badge })
          .then(badge => {
            this.$notify({ title: 'Success', message: this.$root.$t('notifications.campaign.added'), type: 'success' })
            this.sendClose(badge)
          })
          .catch(e => {
            this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
            this.sendClose()
          })
      }
    }
  },
  created() {
    this.toggle({ hash: 'form-badge' })
    if (this.id) {
      let badge = this.getById(this.id)
      this.badge = JSON.parse(JSON.stringify(badge))

      if (this.badge.activationdate && this.badge.deactivationdate) {
        this.period_limited = true
        this.period = []
        this.period.push(this.badge.activationdate)
        this.period.push(this.badge.deactivationdate)
      }
    } else {
      this.badge = {
        name: {},
        description: {},
        successmessage: {},
        score: 0,
        secret: 0,
        media: {
          url: process.env.API + '/media/default/' + this.site.sitekey + '/achievement/'
        },
        maxachieved: -1,
        link: null,
        activationdate: null,
        deactivationdate: null,
        category: {
          id: this.idCampaign
        }
      }

      if (this.idParent) {
        this.badge.parent = {
          id: this.idParent
        }
      }
    }
  },
  destroyed() {
    this.toggle({ hash: 'form-badge' })
  }
}
</script>

<style lang="scss" scoped>
.form-group-container-advanced {
  display: grid;
  grid-column-gap: 24px;
  grid-template-columns: 1fr 280px;
}
.form-group-container {
  display: grid;
  grid-column-gap: 24px;
  grid-template-columns: 140px 1fr 180px;
  grid-template-areas:
    'media name score'
    'media description description'
    'media success success';
  .form-group-container-name {
    grid-area: name;
  }

  .form-group-container-score {
    grid-area: score;
  }

  .form-group-container-description {
    grid-area: description;
  }

  .form-group-container-success {
    grid-area: success;
  }

  .form-group-container-media {
    .button {
      box-sizing: border-box;
      font-size: 13px;
      text-align: center;
      padding: 0;
      width: 100%;
      height: 40px;
      margin-top: 8px;
    }
    grid-area: media;
    > img {
      margin-top: 24px;
      border-radius: 4px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/badges/FormBadge.vue